import script from "./StudioFrontDoor.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioFrontDoor.vue?vue&type=script&setup=true&lang=js"

import "./StudioFrontDoor.vue?vue&type=style&index=0&id=a0e45e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0e45e80"]])

export default __exports__